<aim-header></aim-header>

<ngx-aim-admin-header></ngx-aim-admin-header>

<router-outlet></router-outlet>

<aim-footer></aim-footer>
